// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeBaseEditTemplate_heading__gQjP4","buttonLink":"LandscapeBaseEditTemplate_buttonLink__btkdt","marginTop":"LandscapeBaseEditTemplate_marginTop__JPnE3"};